export * from "./icons/brandsIndex";
export * from "./icons/coloredIndex";
export * from "./icons/nonColoredIndex";
export * from "./icons/bodyStylesIndex";